module.exports = __webpack_public_path__ + "img/swampum-system-header.88221902.png";